module.exports = __webpack_public_path__ + "../resources/img/storebadge_ko.38cc42e8.png";